module.exports = __webpack_public_path__ + "img/268.coffee_accessories.31ee3ce8.svg";